"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex items-center gap-2" };
const _hoisted_3 = {
    key: 0,
    class: "selected-items-count bg-blue text-white p-1 font-bold rounded"
};
const _hoisted_4 = { class: "dropdown-placeholder" };
const _hoisted_5 = { class: "flex items-center gap-2" };
const _hoisted_6 = {
    key: 0,
    class: "dropdown-content rounded-b-md absolute z-10 bg-white min-w-full left-0 top-full border border-gray-dark border-opacity-50 max-h-80 overflow-y-scroll"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    key: 0,
    class: "category-label flex items-center space-x-2 cursor-pointer"
};
const _hoisted_9 = ["value", "onChange"];
const _hoisted_10 = { class: "uppercase whitespace-nowrap" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "uppercase whitespace-nowrap" };
const vue_3 = require("vue");
const i18n_1 = require("../../../common/i18n");
const randomString_1 = __importDefault(require("../../../common/utils/randomString"));
// eslint-disable-next-line no-unused-vars
exports.default = (0, vue_1.defineComponent)({
    __name: 'GroupDropdownInput',
    props: {
        id: {
            type: String,
            default: () => (0, randomString_1.default)(12)
        },
        placeholder: {
            type: String,
            default: (0, i18n_1.trans)("options", "Options", "group_dropdown_input")
        },
        items: {
            type: [Object, Array],
            required: true
        },
        modelValue: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:modelValue'],
    setup(__props, { emit }) {
        var _a;
        const props = __props;
        const itemsList = (0, vue_3.computed)(() => { var _a; return (_a = props.items) !== null && _a !== void 0 ? _a : []; });
        const selectedCategories = (0, vue_3.ref)([]);
        const selectedItems = (0, vue_3.ref)((_a = props.modelValue) !== null && _a !== void 0 ? _a : []);
        const isDropdownOpen = (0, vue_3.ref)(false);
        const dropdownRef = (0, vue_3.ref)(null);
        const searchQuery = (0, vue_3.ref)('');
        // Az érkező elemek csoportosítva vannak-e.
        const isGroupedItems = (0, vue_3.computed)(() => Array.isArray(itemsList.value) === false);
        // Szűrt elemek a keresőmező alapján.
        const filteredItems = (0, vue_3.computed)(() => {
            if (!itemsList.value || itemsList.value.length === 0)
                return;
            if (!searchQuery.value) {
                return isGroupedItems.value ? itemsList.value : { '': { items: itemsList.value } };
            }
            const query = searchQuery.value.toLowerCase();
            const filtered = {};
            if (isGroupedItems.value) {
                for (const [categoryName, category] of Object.entries(itemsList.value)) {
                    const categoryKey = String(categoryName);
                    const filteredItems = category.items.filter((item) => item.text.toLowerCase().includes(query) || categoryKey.toLowerCase().includes(query));
                    if (filteredItems.length > 0 || categoryKey.toLowerCase().includes(query)) {
                        filtered[categoryKey] = { items: filteredItems };
                    }
                }
            }
            else {
                filtered[''] = {
                    items: itemsList.value.filter((item) => item.text.toLowerCase().includes(query))
                };
            }
            return filtered;
        });
        (0, vue_3.onMounted)(() => {
            document.addEventListener('click', handleClickOutside);
            checkSelectedCategories();
        });
        const toggleDropdown = () => {
            isDropdownOpen.value = !isDropdownOpen.value;
            searchQuery.value = '';
        };
        const handleClickOutside = (event) => {
            if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
                isDropdownOpen.value = false;
                searchQuery.value = '';
            }
        };
        // Kategória kiválasztásának kezelése.
        const handleCategorySelect = (categoryName) => {
            var _a, _b;
            if (selectedCategories.value.includes(categoryName)) {
                // Ha a kategória ki van választva, adjuk hozzá az összes hozzá tartozó elemet.
                const categoryItems = (_b = (_a = itemsList.value[categoryName]) === null || _a === void 0 ? void 0 : _a.items.map((item) => item.value)) !== null && _b !== void 0 ? _b : [];
                selectedItems.value = [...new Set([...selectedItems.value, ...categoryItems])];
            }
            else {
                // Ha a kategória nincs kiválasztva, töröljük az összes hozzá tartozó elemet.
                selectedItems.value = selectedItems.value.filter((itemCode) => { var _a; return !((_a = itemsList.value[categoryName]) === null || _a === void 0 ? void 0 : _a.items.some((item) => item.value === itemCode)); });
            }
        };
        // Ellenőrizzük, hogy egy kategóriában minden elem ki van-e választva.
        // Ha igen, akkor kiválasztjuk a hozzájuk tartozó kategóriát.
        const checkSelectedCategories = () => {
            if (isGroupedItems.value) {
                for (const [categoryName, category] of Object.entries(itemsList.value)) {
                    const categoryItems = category.items.map((item) => item.value);
                    if (categoryItems.every(item => selectedItems.value.includes(item))) {
                        if (!selectedCategories.value.includes(categoryName)) {
                            selectedCategories.value.push(categoryName);
                        }
                    }
                    else {
                        const index = selectedCategories.value.indexOf(categoryName);
                        if (index > -1) {
                            selectedCategories.value.splice(index, 1);
                        }
                    }
                }
            }
        };
        const clearSelection = () => {
            selectedCategories.value = [];
            selectedItems.value = [];
            searchQuery.value = '';
        };
        (0, vue_3.watch)(selectedItems, (newValue) => {
            emit('update:modelValue', newValue);
            checkSelectedCategories();
        });
        (0, vue_3.watch)(() => props.modelValue, (newValue) => {
            selectedItems.value = newValue;
            checkSelectedCategories();
        });
        // Amikor az items lista változik, szinkronizáljuk a kiválasztott elemeket.
        // Eltávolítjuk azokat az elemeket, amelyek már nincsenek az elérhető opciók között.
        (0, vue_3.watch)(() => props.items, () => {
            if (!itemsList.value)
                return;
            // Összes elérhető elem értékének összegyűjtése.
            const availableValues = new Set();
            if (isGroupedItems.value) {
                for (const category of Object.values(itemsList.value)) {
                    category.items.forEach((item) => {
                        availableValues.add(item.value);
                    });
                }
            }
            else {
                itemsList.value.forEach((item) => {
                    availableValues.add(item.value);
                });
            }
            // Csak azokat az elemeket tartjuk meg, amelyek még elérhetők.
            const filteredSelectedItems = selectedItems.value.filter(value => availableValues.has(value));
            // Ha változás történt, frissítjük a kiválasztott elemeket.
            if (filteredSelectedItems.length !== selectedItems.value.length) {
                selectedItems.value = filteredSelectedItems;
            }
            checkSelectedCategories();
        }, { deep: true });
        (0, vue_3.onUnmounted)(() => {
            document.removeEventListener('click', handleClickOutside);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: __props.id,
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: "group-dropdown relative bg-gray p-2 cursor-pointer"
            }, [
                (0, vue_2.createElementVNode)("button", {
                    class: "dropdown-button h-full flex items-center justify-between gap-2 w-full",
                    onClick: toggleDropdown
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (selectedItems.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_3, (0, vue_2.toDisplayString)(selectedItems.value.length), 1))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)(__props.placeholder), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (selectedItems.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", {
                                key: 0,
                                class: "clear-selection-icon marso-icon-close text-xs",
                                "aria-hidden": "true",
                                onClick: clearSelection
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("i", {
                            class: (0, vue_2.normalizeClass)(["dropdown-chevron-icon marso-icon-chevron-down transform-gpu transition-transform text-xs", { 'rotate-180': isDropdownOpen.value }]),
                            "aria-hidden": "true"
                        }, null, 2)
                    ])
                ]),
                (isDropdownOpen.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('search', 'Search...', 'group_dropdown_input'),
                                class: "search-input w-full p-2 border border-gray focus:outline-none"
                            }, null, 8, _hoisted_7), [
                                [vue_2.vModelText, searchQuery.value]
                            ]),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(filteredItems), (category, categoryName) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: categoryName,
                                    class: "category px-4 py-2"
                                }, [
                                    ((0, vue_2.unref)(isGroupedItems))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_8, [
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedCategories).value = $event)),
                                                type: "checkbox",
                                                value: categoryName,
                                                class: "category-checkbox h-4 w-4",
                                                onChange: ($event) => (handleCategorySelect(categoryName))
                                            }, null, 40, _hoisted_9), [
                                                [vue_2.vModelCheckbox, selectedCategories.value]
                                            ]),
                                            (0, vue_2.createElementVNode)("span", _hoisted_10, (0, vue_2.toDisplayString)(categoryName), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)({ 'pl-6 mt-1 space-y-1': (0, vue_2.unref)(isGroupedItems) })
                                    }, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(category.items, (item) => {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                                key: item.value,
                                                class: "item-label flex items-center space-x-2 cursor-pointer"
                                            }, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedItems).value = $event)),
                                                    type: "checkbox",
                                                    value: item.value,
                                                    class: "item-checkbox h-4 w-4"
                                                }, null, 8, _hoisted_11), [
                                                    [vue_2.vModelCheckbox, selectedItems.value]
                                                ]),
                                                (0, vue_2.createElementVNode)("span", _hoisted_12, (0, vue_2.toDisplayString)(item.text), 1)
                                            ]));
                                        }), 128))
                                    ], 2)
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
